"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 20 20'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1439.000000, -6186.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(179.000000, 5953.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(360.000000, 93.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(900.000000, 140.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.22755556,20 C4.19555556,20 3.32,19.1946667 3.23466667,18.1653333 L2.05333333,4 L0.666666667,4 C0.298666667,4 0,3.70133333 0,3.33333333 C0,2.96533333 0.298666667,2.66666667 0.666666667,2.66666667 L6,2.66666667 L6,2 C6,0.896888889 6.89688889,0 8,0 L12,0 C13.1031111,0 14,0.896888889 14,2 L14,2.66666667 L19.3333333,2.66666667 C19.7013333,2.66666667 20,2.96533333 20,3.33333333 C20,3.70133333 19.7013333,4 19.3333333,4 L17.9466667,4 L16.7662222,18.1662222 C16.6808889,19.1946667 15.8053333,20 14.7733333,20 L5.22755556,20 Z M4.56266667,18.0551111 C4.59111111,18.3982222 4.88266667,18.6666667 5.22755556,18.6666667 L14.7733333,18.6666667 C15.1173333,18.6666667 15.4097778,18.3982222 15.4373333,18.0551111 L16.6088889,4 L3.39111111,4 L4.56266667,18.0551111 Z M12.6666667,2.66666667 L12.6666667,2 C12.6666667,1.632 12.368,1.33333333 12,1.33333333 L8,1.33333333 C7.632,1.33333333 7.33333333,1.632 7.33333333,2 L7.33333333,2.66666667 L12.6666667,2.66666667 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,15.3333333 C7.632,15.3333333 7.33333333,15.0346667 7.33333333,14.6666667 L7.33333333,8 C7.33333333,7.632 7.632,7.33333333 8,7.33333333 C8.368,7.33333333 8.66666667,7.632 8.66666667,8 L8.66666667,14.6666667 C8.66666667,15.0346667 8.368,15.3333333 8,15.3333333 Z",
    id: "Path"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,15.3333333 C11.632,15.3333333 11.3333333,15.0346667 11.3333333,14.6666667 L11.3333333,8 C11.3333333,7.632 11.632,7.33333333 12,7.33333333 C12.368,7.33333333 12.6666667,7.632 12.6666667,8 L12.6666667,14.6666667 C12.6666667,15.0346667 12.368,15.3333333 12,15.3333333 Z",
    id: "Path"
  })))))), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "2",
    y1: "18",
    x2: "18",
    y2: "2",
    stroke: "currentColor"
  }));
});